import { Theme, createStyles } from "@material-ui/core";

export const styles = ({ palette, spacing }: Theme) => createStyles({
    container: {
        textAlign: "center",
    },
    number: {
        display: "inline-block",
        margin: spacing.unit * 2,
        padding: spacing.unit * 3,
        borderRadius: "100%",
        backgroundColor: palette.primary.main,
        color: "white",
        fontSize: 40,
        width: 50,
        height: 50
    }
});


// WEBPACK FOOTER //
// ./src/components/Statistics/StatisticsElement.style.tsx